import { IFirmware, IFirmwareStatistic } from './types';

export function getFirmwareFamily(productType: {
  productCode: string;
  variant: string;
}): Array<{ productCode: string; variant: string }> {
  const { productCode: p, variant: v } = productType;

  const FAMILIES = [
    ['1', '2', '4', '100', '102'],
    ['3', '103', '5', '105'],
    ['200', '201', '300'],
    ['6'],
  ];

  const matchingGroup = FAMILIES.find((group) =>
    group.includes(p),
  ) ?? [p];

  return matchingGroup.map((code) => ({
    productCode: code,
    variant: v,
  }));
}

export function canDeleteFirmware(
  firmware: IFirmware,
  firmwareStatistics: IFirmwareStatistic,
) {
  return (
    firmware.firmwareId >= 1000 &&
    firmwareStatistics.reportedCount == 0
  );
}

export function canBeRolledOut(
  firmware: IFirmware,
  _firmwareStatistics: IFirmwareStatistic,
): boolean {
  return firmware.firmwareId < 1000;
}
